import { createSlice, createSelector } from '@reduxjs/toolkit';
import { getAll, edit, addV2, saveManufacturerUser, editManufacturerUser, deleteManufacturerUser, getManufacturerUsers } from '../api/manufacturersapi'; //add,editDetails
/*import moment from "moment";*/

const slice = createSlice({
    name: 'manufacturers',
    initialState: {
        list: [],
        isLoading: false,
        lastFetch: null,
        saveStatus: 'idle', // 'saving', 'succeeded', 'failed'
        saveError: null,
        manufacturerUsers: [],
    },
    reducers: {
        manufacturersRequested: (manufacturers) => {
            manufacturers.isLoading = true;
        },
        manufacturersReceived: (manufacturers, action) => {
            manufacturers.list = action.payload;
            manufacturers.isLoading = false;
            manufacturers.lastFetch = Date.now();
        },
        manufacturersRequestFailed: (manufacturers) => {
            manufacturers.list = [];
            manufacturers.isLoading = false;
        },
        manufacturerAdded: (manufacturers, action) => {
            manufacturers.list.data.push(action.payload);
        },
        manufacturerEdited: (manufacturers, action) => {
            const index = manufacturers.list.data.findIndex(
                (manufacturer) => manufacturer.id === action.payload.id
            );
            if (index >= 0) {
                manufacturers.list.data[index] = action.payload;
            }
        },
        saveStarted: (state) => {
            state.saveStatus = 'saving';
        },
        saveSucceeded: (state) => {
            state.saveStatus = 'succeeded';
        },
        saveFailed: (state, action) => {
            state.saveStatus = 'failed';
            state.saveError = action.payload;
        },
        resetSaveStatus: (state) => {
            state.saveStatus = 'idle';
        },
        // ========== Manufacturer Users ==========
        manufacturerUsersReceived: (state, action) => {
            state.manufacturerUsers = action.payload;
        },
        manufacturerUserAdded: (state, action) => {
            state.manufacturerUsers.push(action.payload);
        },
        manufacturerUserEdited: (state, action) => {
            const index = state.manufacturerUsers.findIndex(
                (u) => u.id === action.payload.id
            );
            if (index >= 0) state.manufacturerUsers[index] = action.payload;
        },
        manufacturerUserDeleted: (state, action) => {
            state.manufacturerUsers = state.manufacturerUsers.filter(
                (u) => u.id !== action.payload
            );
        },
    },
});

const {
    manufacturersRequested,
    manufacturersReceived,
    manufacturersRequestFailed,
    manufacturerAdded,
    manufacturerEdited,
    saveStarted,
    saveSucceeded,
    saveFailed,
    manufacturerUsersReceived,
    manufacturerUserAdded,
    manufacturerUserEdited,
    manufacturerUserDeleted,
} = slice.actions;
export default slice.reducer;

// Action Creators

export const loadManufacturers = () => async (dispatch) => {
    dispatch(manufacturersRequested());
    try {
        const response = await getAll();
        dispatch(manufacturersReceived(response.data));
    } catch (error) {
        dispatch(manufacturersRequestFailed(error.message));
    }
};

export const getManufacturers = createSelector(
    (state) => state.manufacturers.list,
    (manufacturers) => manufacturers
);

export const resetStatus = () => async (dispatch) => {
    dispatch(resetSaveStatus());
};

export const addManufacturer = (manufacturerData, onSuccess, onError) => async (dispatch) => {
    dispatch(saveStarted());
    try {
        const response = await addV2({ options: { data: manufacturerData } });
        if (response.data.success) {
            dispatch(manufacturerAdded(response.data.data));
            dispatch(saveSucceeded());
            if (onSuccess) { onSuccess(); }
        } else {
            dispatch(saveFailed(response.data.message));
            if (onError) { onError(response.data.message); }
        }
    } catch (error) {
        console.error('There was an error adding the manufacturer:', error);
    }
};

export const editManufacturer = (manufacturerData) => async (dispatch) => {
    dispatch(saveStarted());

    try {
        const response = await edit({ options: { data: manufacturerData } });
        if (response.data.success) {
            dispatch(manufacturerEdited(response.data));
            dispatch(saveSucceeded());
        } else {
            dispatch(saveFailed(response.data.message));
        }
    } catch (error) {
        dispatch(saveFailed(error.message));
        console.error('There was an error editing the manufacturer:', error);
    }
};

// ================= Manufacturer Users =================
export const loadManufacturerUsers = (manufacturerId) => async (dispatch) => {
    try {
        const response = await getManufacturerUsers(manufacturerId);
        dispatch(manufacturerUsersReceived(response.data.data));
    } catch (error) {
        console.error("Failed to load manufacturer users:", error);
    }
};

export const addManufacturerUser = (requestData, onSuccess, onError) => async (dispatch) => {
    try {
        const response = await saveManufacturerUser({ data: requestData });
        if (response.data.success) {
            dispatch(manufacturerUserAdded(response.data.data));
            if (onSuccess) onSuccess();
        } else {
            if (onError) onError(response.data.message);
        }
    } catch (error) {
        console.error("Failed to add manufacturer user:", error);
    }
};

export const editManufacturerUserAction = (requestData) => async (dispatch) => {
    try {
        const response = await editManufacturerUser({ data: requestData });
        if (response.data.success) {
            dispatch(manufacturerUserEdited(response.data.data));
        }
    } catch (error) {
        console.error("Failed to edit manufacturer user:", error);
    }
};

export const deleteManufacturerUserAction = ({ manufacturerId, userId }) => async (dispatch) => {
    try {
        const response = await deleteManufacturerUser({ manufacturerId, userId });

        if (response.data.success) {
            dispatch(manufacturerUserDeleted(userId));
        }
    } catch (error) {
        console.error("Failed to delete manufacturer user:", error);
    }
};


export const getManufacturerUsersSelector = createSelector(
    (state) => state.manufacturers.manufacturerUsers,
    (users) => users
);


export const { resetSaveStatus } = slice.actions;
